import styled from 'styled-components';

export const TitleWrapperV2 = styled.div`
  ${props => props.alignStart
    ? 'align-self: flex-start;'
    : `
      margin-left: auto;
      margin-right: auto;
    `
  }
  ${props => props.maxWidth && `max-width: ${props.maxWidth}px;`}
  ${props => props.marginBottom >= 0
  ? `margin-bottom: ${props.marginBottom}px;`
  : `margin-bottom: 40px;`
  }
`;

export const TitleV2 = styled.h1`
  color: ${props => props.theme.color.primary.v600};
  font-weight: bold;
  margin-bottom: 8px;
  text-align: left;
  text-transform: ${props => props.uppercase && 'uppercase'};
  ${props => props.fontSize >= 0
    ? `font-size: ${props.fontSize}px;`
    : `font-size: 18px;`
  }

  @media (min-width: ${props => props.theme.breakpoint.md}px) {
    font-size: 28px;
    ${props => props.fontSize >= 0
      ? `font-size: ${props.fontSize}px;`
      : `font-size: 28px;`
    }
  }

  ${TitleWrapperV2} > & {
    margin-bottom: 0;
  }
`;

export const SubtitleV2 = styled.p`
  color: ${props => props.theme.color.neutral.v500};
  font-size: 14px;
  line-height: 1.5;
  max-width: 680px;
  text-align: left;

  @media (min-width: ${props => props.theme.breakpoint.md}px) {
    font-size: initial;
  }

  ${TitleWrapperV2} > & {
    margin-bottom: 0;
  }
`;
